import { render, staticRenderFns } from "./VersionChecker.vue?vue&type=template&id=acb84148&"
import script from "./VersionChecker.vue?vue&type=script&lang=ts&"
export * from "./VersionChecker.vue?vue&type=script&lang=ts&"
import style0 from "./VersionChecker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports